import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/en/services/pharmacovigilance/qppv-local-representative")({
  head: () => buildRouteHead("/en/services/pharmacovigilance/qppv-local-representative"),
  component: PVOffering,
});

